import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import moment from 'moment';

import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';

const auth = new Auth();

export default class CommonSearches extends Component {
    constructor(props){
        super(props);
  
        this.state = {
            searchWordsKPI: props.words,
            searchWordsKPIrelated: [],
            showModal: false,
            isLoading: true
        };
  
    }

    componentDidUpdate(prevProps){
      if(prevProps.relatedWords !== this.props.relatedWords){
          this.showRelated(this.props.relatedWords);
      }

      if(prevProps.words !== this.props.words){
        this.setState({
          searchWordsKPI: this.props.words,
          searchWordsKPIrelated: [],
          showModal: false,
          isLoading: true
        });
      }
    }

    async showRelated(word){
      if(this.props.area !== 'client' && this.props.isFilteredSearch === false){
        this.setState({
          showModal : true,
          searchWordsKPIrelated: [],
          isLoading: true
        });
        let accessToken = await auth.getToken();
        fetch(`/api/searchWordsKPIRelated${this.props.area}`, {
              method : "GET",
              headers : {
                  'Authorization': "Bearer " + accessToken,
                  'filtereddate': this.props.searchesDate,
                  'mainword': word
              }
          }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
              this.setState({
                searchWordsKPIrelated : data[0],
                isLoading: false
              });
              
        }).catch((error) => {
            window.apiError(error);
        });
      }
      
      
    }
  
    render(){
      const columns = [{
        dataField: 'Word',
        text: 'Search Word',
        sort: true,
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.showRelated(row.Word)
          }
        },
        attrs: { className: this.props.isFilteredSearch === false ? 'cursor-pointer btn-link' : '' }
      }, {
        dataField: 'WordCount',
        text: 'Word Count',
        sort: true,
        sortFunc: (a, b, order, dataField, rowA, rowB) => {
          if (order === 'asc') {
            return parseInt(b) - parseInt(a);
          }
          return parseInt(a) - parseInt(b); // desc
        }
      }
    ];

    const relatedColumns = [{
          dataField: 'WordString',
          text: 'Search Word',
          sort: true
        }, {
          dataField: 'WordStringCount',
          text: 'Word Count',
          sort: true,
          sortFunc: (a, b, order, dataField, rowA, rowB) => {
            if (order === 'asc') {
              return parseInt(b) - parseInt(a);
            }
            return parseInt(a) - parseInt(b); // desc
          }
        }
    ];

    const defaultSorted = [{
      dataField: 'WordStringCount',
      order: 'asc'
    }];
  
      return (
          <div>         
            <ToolkitProvider
              keyField="Word"
              data={ this.state.searchWordsKPI }
              columns={ columns }
            >
              {
                props => (
                  <div  id="table-wrapper" style={{width: "95%", fontSize: "11.5px"}}>
                    <BootstrapTable
                      { ...props.baseProps }
                    />
                  </div>
                )
              }
            </ToolkitProvider>

            <Modal size="lg" show={this.state.showModal} centered onHide={() => this.setState({ showModal : false })} dialogClassName="active related-word-modal" animation={false} >
                <button type="button" className="close position-absolute" style={{ right: "5px"}} onClick={() => this.setState({ showModal : false })}><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                {this.state.isLoading && (
                  <IsLoadingBar />
                )}
                {!this.state.isLoading && (
                  <ToolkitProvider
                    keyField="Word"
                    data={ this.state.searchWordsKPIrelated }
                    columns={ relatedColumns }                    
                  >
                    {
                      props => (
                        <div id="table-wrapper" style={{width: "95%", fontSize: "11.5px", maxWidth: "400px", margin: "auto", paddingTop: "20px"}}>
                          <BootstrapTable
                            { ...props.baseProps }
                            keyField="Word"
                            defaultSorted={ defaultSorted } 
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                )}
                
            </Modal>
            
            
          </div>
          
      );
    }
  }